import { action, select } from 'satcheljs/lib/legacy';
import store from '../store/store';
/**
 * Action called when we select discard in txp options page.  We reset the txp options in the store
 */
export default select({
    optionState: function () { return store; },
})(action('discardTxpOption')(function discardTxpOption(state) {
    var optionState = state.optionState;
    optionState.CreateEventsFromEmailAsPrivate = null;
    optionState.EventsFromEmailEnabled = null;
    optionState.Events = {
        DiningEventsFromEmailEnabled: null,
        EntertainmentEventsFromEmailEnabled: null,
        FlightEventsFromEmailEnabled: null,
        HotelEventsFromEmailEnabled: null,
        InvoiceEventsFromEmailEnabled: null,
        PackageDeliveryEventsFromEmailEnabled: null,
        RentalCarEventsFromEmailEnabled: null,
    };
}));
//# sourceMappingURL=discardTxpOption.js.map